export const DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
export const DAY_ABBR = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
export const MONTH_ABBR = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
export const MONTH_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Get local date as YYYY-MM-DD string (avoids UTC timezone issues) */
export function localISO(d) {
  const dt = d || new Date();
  return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
}

export function uid(len = 7) {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let r = '';
  for (let i = 0; i < len; i++) r += c[Math.floor(Math.random() * c.length)];
  return r;
}

export function timeToMins(t) {
  const parts = t.split(' ');
  const [h, m] = parts[0].split(':').map(Number);
  const pm = parts[1] === 'PM';
  let hour = h;
  if (pm && h !== 12) hour += 12;
  if (!pm && h === 12) hour = 0;
  return hour * 60 + m;
}

// Canonical slot identity — mirrors slot_uid() in backend/server.py.
//
// A slot is identified by the day it falls on and the time it starts, so any
// regeneration of the schedule reproduces the same ids and the bookings that
// point at them stay attached. The admin UI used to mint random ids here,
// which is one of the two ways bookings became orphaned. The server re-derives
// the id on write regardless; this keeps the optimistic UI state identical to
// what will come back from the API.
export function slotUid(iso, time) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  if (!time || !/^\s*\d{1,2}:\d{2}\s*(AM|PM)\s*$/i.test(time)) return null;
  const mins = timeToMins(time.trim().toUpperCase());
  if (!Number.isFinite(mins)) return null;
  const hh = String(Math.floor(mins / 60)).padStart(2, '0');
  const mm = String(mins % 60).padStart(2, '0');
  return `s_${iso.replace(/-/g, '')}_${hh}${mm}`;
}

export function fmt(n) { return '$' + Number(n).toFixed(2); }

export function calcPricing(price, guests, taxRate, feeRate) {
  const subtotal = price * guests;
  const fee = subtotal * (feeRate / 100);
  const tax = (subtotal + fee) * (taxRate / 100);
  return { subtotal, fee, tax, total: subtotal + fee + tax };
}

export function formatTime(h, m, ap) {
  return `${h}:${String(m).padStart(2,'0')} ${ap}`;
}

export function formatHour12(h) {
  const hr = ((Number(h) % 24) + 24) % 24;
  const period = hr < 12 ? 'AM' : 'PM';
  const h12 = hr % 12 === 0 ? 12 : hr % 12;
  return `${h12}:00 ${period}`;
}

export function generate30DaySlots() {
  const slots = [];
  const today = new Date();
  for (let d = 0; d < 30; d++) {
    const dt = new Date(today);
    dt.setDate(today.getDate() + d);
    const dayName = DAY_NAMES[dt.getDay()];
    const dateStr = `${MONTH_ABBR[dt.getMonth()]} ${dt.getDate()}`;
    const iso = localISO(dt);
    for (let h = 9; h <= 17; h++) {
      for (const m of [0, 30]) {
        if (h === 17 && m > 0) continue;
        const h12 = h === 0 ? 12 : (h > 12 ? h - 12 : h);
        const ampm = h < 12 ? 'AM' : 'PM';
        const time = `${h12}:${String(m).padStart(2,'0')} ${ampm}`;
        slots.push({
          id: slotUid(iso, time), day: dayName, date: dateStr,
          time,
          price: 68, capacity: 10, booked: 0, _iso: iso,
        });
      }
    }
  }
  return slots;
}
